import ENDPOINTS, { APP_NAME } from '@zet/end-points'
import { zetApi } from '@zet/network'

import { ICustomerCount, IFilterDto } from '../types'

const getFilterDto = (filterDto: IFilterDto) => {
  return encodeURIComponent(JSON.stringify(filterDto))
}

export const getListOfCustomer = async (
  searchText: string,
  sortType: string,
  type: string,
  offset: number,
  selectedStatus: Array<number>,
  subAgentId: string | number,
  selectedSource?: Array<string>,
  limit = 10
) => {
  const { data } = await zetApi.get(
    `/customer/list/v2?type=${type}&subAgentId=${subAgentId}&searchText=${searchText}&offset=${
      offset * limit
    }&limit=${limit}&sortType=${sortType}&filters=${getFilterDto({
      filters: [
        {
          name: 'status',
          alias: 't',
          value: selectedStatus.length > 0 ? selectedStatus : null,
        },
        {
          name: 'customerAdditionSource',
          value: selectedSource,
        },
      ],
      pagination: {
        offset: offset * limit,
        limit: limit,
      },
      sort: {
        order: 'descend',
        key: 'payout',
      },
    })}`
  )
  return { nextOffset: offset + 1, ...data?.data }
}

export async function getCustomerCount(subAgentId: string | number) {
  try {
    const response = await zetApi.request<ICustomerCount>({
      url: ENDPOINTS[APP_NAME].getCustomerCount.endpoint,
      method: ENDPOINTS[APP_NAME].getCustomerCount.method,
      params: {
        subAgentId: APP_NAME === 'zet-app' ? subAgentId : null,
      },
    })
    return response.data
  } catch (error) {
    console.log(error)
    throw new Error('Unable to fetch customer count')
  }
}
